<template>
  <transition name="fade">
    <div class="preloader">
      <div class="logo mb-5">
        <v-img :src="require('@/assets/logo-argecam.png')"></v-img>
      </div>

      <hollow-dots-spinner
        :animation-duration="1000"
        :dot-size="10"
        :dots-num="4"
        color="#171f2e"
      />
    </div>
  </transition>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
  name: "preloader",
  components: {
    HollowDotsSpinner
  },
  data: () => ({
    show: true
  })
};
</script>

<style lang="scss" scoped>
.preloader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100vw;
  height: 100%;
  background-color: #fff;
  z-index: 9999;
}
.logo {
  width: 60px;
}
</style>
